import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { Utente } from '../models/utente.model';
import { RuoloUtente } from '../models/utente.ruolo.model';


@Injectable({
  providedIn: 'root',
})
export class UtentiService{
  apiUrl: string = environment.apiUrl +"utente";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
    ) {}


  get(): Observable<any> {
    const httpOptions = {
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }
  getRuoli(): Observable<RuoloUtente[]> {
    const httpOptions = {
      reportProgress: true,
    };
    return this.http.get<RuoloUtente[]>(this.apiUrl+"/ruoli", httpOptions);
  }

  getByIdAuth0(idAuth0:String): Observable<any> {
    const url = this.apiUrl+"/auth0/"+idAuth0;
    const httpOptions = {
      reportProgress: true,
    };
   // this.logger.info("[UTENTI SERVICE] GET BY ID AUTH0: " + httpOptions);
    return this.http.get(url, httpOptions);
  }

  getByMail(mail:String): Observable<any> {
    const url = this.apiUrl+"/mail/"+mail;
    const httpOptions = {
      reportProgress: true,
    };
    return this.http.get(url, httpOptions);
  }

  crea(utente:Utente): Observable<any> {
    const httpOptions = {
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, utente, httpOptions);
  }

  modifica(utente:Utente): Observable<any> {
    const httpOptions = {
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+utente.id, utente, httpOptions);
  }

  elimina(idUtente:number): Observable<any> {
    const httpOptions = {
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idUtente, httpOptions);
  }
}
